















import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from './components/HelloWorld.vue';
import test from './components/test.vue'
import logos from './components/logos.vue'
import search from './components/search.vue'
import HomeTab from './components/HomeTab.vue'
import loding from './components/loding.vue'
import login from "./components//login.vue";

@Component({
  components: {
    HelloWorld,
    test,
    logos,
    search,
    HomeTab,
    loding,
    login
  },
})
export default class App extends Vue {}
